class PredictiveSearch extends HTMLElement {
  constructor () {
    super()
    this.searchTrigger = document.querySelector('[data-search-trigger]')
    this.searchClose = this.querySelector('[data-search-close]')
    this.input = this.querySelector('[data-predictive-search-input]')
    this.resultsContainer = this.querySelector('[data-predictive-search-results]')
    this.isOpen = false
    this.abortController = new AbortController()

    this.bindEvents()
  }

  bindEvents () {
    // Toggle search on trigger click
    if (this.searchTrigger) {
      this.searchTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        if (!this.isOpen) {
          this.open()
        } else {
          this.close()
        }
      })
    }

    // Close search
    if (this.searchClose) {
      this.searchClose.addEventListener('click', (e) => {
        e.preventDefault()
        this.close()
      })
    }

    // Handle input changes
    if (this.input) {
      this.input.addEventListener('input', this.debounce(() => {
        const searchTerm = this.input.value.trim()
        this.getSearchResults(searchTerm)
      }, 300))
    }

    // Handle trending/suggestion term clicks
    if (this.resultsContainer) {
      this.resultsContainer.addEventListener('click', (event) => {
        const termButton = event.target.closest('[data-search-term]')
        if (termButton) {
          event.preventDefault()
          const term = termButton.dataset.searchTerm
          this.input.value = term
          this.input.focus()
          this.getSearchResults(term)
        }
      })
    }

    // Close on click outside
    document.addEventListener('click', (event) => {
      if (this.isOpen && !this.contains(event.target) && !this.searchTrigger.contains(event.target)) {
        this.close()
      }
    })

    // Close on escape
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.close()
      }
    })
  }

  open () {
    this.classList.add('sr-Overlay_Active')
    this.input.focus()
    this.isOpen = true
    document.documentElement.style.overflow = 'hidden'

    // Load initial results (trending/recommended)
    this.getSearchResults('')
  }

  close () {
    this.classList.remove('sr-Overlay_Active')
    this.isOpen = false
    document.documentElement.style.overflow = ''
    this.input.value = ''
    this.resultsContainer.innerHTML = ''
  }

  getSearchResults (searchTerm) {
    // Abort previous request
    this.abortController.abort()
    this.abortController = new AbortController()

    const url = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,query&resources[limit]=4&section_id=ajax-search-results`

    fetch(url, {
      signal: this.abortController.signal,
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const resultsHtml = doc.getElementById('shopify-section-ajax-search-results').innerHTML
        this.resultsContainer.innerHTML = resultsHtml
      })
      .catch(error => {
        if (error.name === 'AbortError') return
        console.error('Search error:', error)
      })
  }

  debounce (fn, wait) {
    let timeout
    return function executedFunction (...args) {
      const later = () => {
        clearTimeout(timeout)
        fn(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}

customElements.define('header-search', PredictiveSearch)
